import React from "react";
import { Button } from "reactstrap";
// import { get } from 'object-path'

import { FormGroup, FormFeedback, Label } from "reactstrap";

const FormField = ({
  input,
  options,
  optionField = "label",
  label,
  defaultValue, // array key value
  disabled = false,
  placeholder = "Choose an option...",
  defaultErrorMessage = "This must be defined", // set to null if you want to pass your own error message
  removeField,
  meta: { touched, error },
}) => {
  let errorComponent;
  let validationState;

  if (touched && error) {
    let errorMessage;

    // Format if joi message
    if (error[0] === '"' && error.slice(1).indexOf('"')) {
      errorMessage = `${label || "This"}${error.substr(error.slice(1).indexOf('"') + 2)}`;
    } else {
      errorMessage = error;
    }

    if (!errorMessage) {
      errorMessage = defaultErrorMessage;
    }
    errorComponent = <FormFeedback>{errorMessage || error}</FormFeedback>;
    validationState = "error";
  }

  let setValue = input.value ? input.value : defaultValue ? defaultValue : undefined;

  return (
    <FormGroup validationState={validationState} controlId="formControlsSelect">
      <Label>{label}</Label>
      {removeField ? (
        <div className="pull-right remove-form-control">
          <Button bsStyle="default" onClick={removeField}>
            X
          </Button>
        </div>
      ) : null}

      <select {...input} className="form-control" disabled={disabled} value={setValue}>
        {/*let default = (defaultValue && !) ?*/}
        <option value="">{placeholder}</option>
        {options.map((option, i) => {
          return (
            <option key={i} value={option.id}>
              {option[optionField]}
            </option>
          );
        })}
      </select>
      {errorComponent}
      <FormFeedback />
    </FormGroup>
  );
};

// FormField.propTypes = {
//   input: PropTypes.object,
//   defaultValue: PropTypes.string,
//   label: PropTypes.string,
//   type: PropTypes.string,
//   touched: PropTypes.bool,
//   error: PropTypes.string,
//   placeholder: PropTypes.string,
//   removeField: PropTypes.func,
// };

export default FormField;
